import { Provider } from '@angular/core';
import { CAPTCHA_REPOSITORY_PORT } from './domain/captcha.repository.port';
import { CaptchaRepositoryAdapter } from './infrastructure/captcha-repository-adaptar.service';

export function provideCaptchaRepository(): Provider[] {
  return [
    {
      provide: CAPTCHA_REPOSITORY_PORT,
      useClass: CaptchaRepositoryAdapter,
    },
  ];
}
